export default __webpack_public_path__ + "static/media/mobile_cast.b9bdd40e.svg";